// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__1D7z2","modalForm":"UpgradeEpcsModal_modalForm__1qCxp","modalFooter":"UpgradeEpcsModal_modalFooter__1dJRl"};